import useTranslation from "@/hooks/useTranslation";
import { PRODUCT_BY, ProductBy } from "@/pages/dashboard/hooks/useProductImpact";
import { Segmented } from "antd";
import { useState } from "react";
import Widget from "../../../components/Widget/Widget";
import { ImpactMetric } from "../../../utils/types";
import PerCategory from "./PerCategory";
import PerProduct from "./PerProduct";

type ContributorsType = "product" | "category";

export default function ProductImpactTopContributors({ metric }: { metric: ImpactMetric }) {
  const translation = useTranslation();
  const [by, setBy] = useState<ProductBy>("total");
  const [type, setType] = useState<ContributorsType>("product");

  return (
    <Widget
      title={"Top contributing products"}
      tooltip={translation["dashboard"]["product"]["top_contributors"]}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          <Segmented
            options={PRODUCT_BY}
            onChange={setBy}
            value={by}
          />
          <Segmented
            options={[
              { label: "Per product", value: "product" },
              { label: "Per category", value: "category" },
            ]}
            onChange={setType}
          />
        </div>
        {type === "product" ? (
          <PerProduct
            metric={metric}
            by={by}
          />
        ) : (
          <PerCategory
            metric={metric}
            by={by}
          />
        )}
      </div>
    </Widget>
  );
}
